export default "__VITE_ASSET__DJ_3SO9p__"